var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftTeams = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/mike",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "17.372046%",
  y1: "-6.510297%",
  x2: "82.6280417%",
  y2: "106.510472%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A62C3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D55BD",
  offset: "50%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3940AB",
  offset: "100%"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "microsoft-teams",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(16.183042, 2.228802)",
  fill: "#5059C9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.555983849,6.14266487 L6.75477793,6.14266487 C7.34041454,6.14266487 7.81516016,6.6174105 7.81516016,7.20304711 L7.81516016,12.8493244 C7.81516016,15.0016904 6.07033109,16.7465195 3.91796501,16.7465195 L3.91796501,16.7465195 L3.8995424,16.7465195 C1.74717631,16.746821 0.00209959623,15.0022396 0.00178734859,12.8498735 L0.00178734859,12.8493136 L0.00178734859,6.69686137 C0.00178734859,6.39078331 0.249916555,6.14266487 0.555983849,6.14266487 L0.555983849,6.14266487 L0.555983849,6.14266487 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 4.74562584,
  cy: 2.51502557,
  r: 2.51144011
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.686406, 0.000000)",
  fill: "#7B83EB"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 6.42888829,
  cy: 3.6276393,
  r: 3.6276393
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2659273,8.37146703 L1.03375505,8.37146703 C0.455095559,8.38578735 -0.00265948856,8.86601346 0.0107671602,9.44469448 L0.0107671602,15.8845868 C-0.0700403769,19.3572005 2.67732974,22.2389341 6.14984657,22.3239192 C9.62236339,22.2389341 12.3697227,19.3572005 12.288926,15.8845868 L12.288926,9.44469448 C12.3023311,8.86601346 11.8445868,8.38578735 11.2659273,8.37146703 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.3943472,8.37146703 L13.3943472,17.3959085 C13.3915693,17.8097443 13.1407914,18.1815236 12.7581157,18.3390902 C12.6362746,18.3906326 12.5053244,18.4172275 12.3730283,18.4172275 L7.1882961,18.4172275 C7.11574697,18.2330552 7.04877524,18.0488829 6.99295828,17.8591332 C6.79759892,17.2187349 6.69791655,16.5530013 6.69716285,15.883467 L6.69716285,9.4430148 C6.68374697,8.86525976 7.14074832,8.38578735 7.71848183,8.37146703 L13.3943472,8.37146703 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.836253,8.37146703 L12.836253,17.9540027 C12.836253,18.0862997 12.8096593,18.217247 12.7581157,18.3390902 C12.6005491,18.7217658 12.2287699,18.9725545 11.8149341,18.9753217 L7.45060565,18.9753217 C7.35572544,18.7911494 7.26643338,18.6069771 7.1882961,18.4172275 C7.11015882,18.2274778 7.04877524,18.0488829 6.99295828,17.8591332 C6.79759401,17.2187404 6.69791928,16.5529965 6.69716285,15.883467 L6.69716285,9.4430148 C6.68374697,8.86525976 7.14074832,8.38578735 7.71848183,8.37146703 L12.836253,8.37146703 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.836253,8.37146703 L12.836253,16.8378143 C12.832,17.4001077 12.3772275,17.8548802 11.8149341,17.8591332 L6.99296904,17.8591332 C6.79760478,17.2187404 6.69793005,16.5529965 6.69717362,15.883467 L6.69717362,9.4430148 C6.68375774,8.86525976 7.14075908,8.38578735 7.7184926,8.37146703 L12.836253,8.37146703 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.278148,8.37146703 L12.278148,16.8378143 C12.273895,17.4001077 11.8191225,17.8548802 11.2568291,17.8591332 L6.99296904,17.8591332 C6.79760478,17.2187404 6.69793005,16.5529965 6.69717362,15.883467 L6.69717362,9.4430148 C6.68375774,8.86525976 7.14075908,8.38578735 7.7184926,8.37146703 L12.278148,8.37146703 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3943472,5.48610498 L13.3943472,7.24411306 C13.299467,7.24969044 13.210175,7.2552786 13.1152948,7.2552786 C13.0204145,7.2552786 12.9311225,7.24970121 12.8362423,7.24411306 C12.64786,7.23161238 12.4610283,7.20172275 12.278148,7.154821 C11.1479944,6.88717404 10.2143155,6.09458574 9.76670794,5.02289098 C9.68969474,4.84291352 9.62989623,4.65604814 9.58811306,4.46479677 L12.3730175,4.46479677 C12.9361938,4.46692867 13.3922046,4.92292867 13.3943472,5.48610498 L13.3943472,5.48610498 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  id: "C-link",
  opacity: 0.2,
  transform: "translate(9.765814, 5.017497)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.07043876,1.02670256 L3.07043876,2.22661642 C2.88205653,2.21411575 2.69522476,2.18422611 2.51234455,2.13732436 C1.3821909,1.86967741 0.448512,1.0770891 0.000904441454,0.00539434724 L2.04911978,0.00539434724 C2.61228533,0.00752624495 3.0682961,0.463537012 3.07043876,1.02670256 L3.07043876,1.02670256 Z",
  id: "C"
})), /*#__PURE__*/React.createElement("g", {
  id: "C-link",
  opacity: 0.2,
  transform: "translate(9.765814, 5.017497)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.07043876,1.02670256 L3.07043876,2.22661642 C2.88205653,2.21411575 2.69522476,2.18422611 2.51234455,2.13732436 C1.3821909,1.86967741 0.448512,1.0770891 0.000904441454,0.00539434724 L2.04911978,0.00539434724 C2.61228533,0.00752624495 3.0682961,0.463537012 3.07043876,1.02670256 L3.07043876,1.02670256 Z",
  id: "C"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.278148,6.04419919 L12.278148,7.15481023 C11.1479944,6.88716327 10.2143155,6.09457497 9.76670794,5.02288022 L11.2568291,5.02288022 C11.8200054,5.02502288 12.2760054,5.48103365 12.278148,6.04419919 L12.278148,6.04419919 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.02298789,5.02288022 L11.2551494,5.02288022 C11.8201346,5.02288022 12.2781373,5.48089367 12.2781373,6.0458681 L12.2781373,16.2780296 C12.2781373,16.8430148 11.8201238,17.3010175 11.2551494,17.3010175 L1.02298789,17.3010175 C0.458002692,17.3010175 0,16.843004 0,16.2780296 L0,6.0458681 C0,5.48089367 0.458013459,5.02288022 1.02298789,5.02288022 Z",
  id: "Path",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "8.8313432 8.91728668 6.78590579 8.91728668 6.78590579 14.4871063 5.48275639 14.4871063 5.48275639 8.91728668 3.44681561 8.91728668 3.44681561 7.83681292 8.8313432 7.83681292"
}))))));
export { SvgMicrosoftTeams as ReactComponent };
export default __webpack_public_path__ + "images/microsoft-teams.svg";